import React, { useState, useEffect, useRef } from 'react';
import { default as ReactMarquee } from 'react-fast-marquee';

const Marquee = ({ children, delay, alwaysEnabled }) => {
  const marqueeWrapperRef = useRef(null);
  const childrenRef = useRef(null);
  const [enableMarquee, setEnableMarquee] = useState(alwaysEnabled || null);

  useEffect(() => {
    if (!alwaysEnabled && marqueeWrapperRef?.current && childrenRef?.current) {
      const wrapperWidth = marqueeWrapperRef.current.clientWidth; // the width of the container where the Marquee will be in
      const childrenWidth = childrenRef.current.scrollWidth; // the width of the Marquee children

      setEnableMarquee(wrapperWidth < childrenWidth);
    }
  }, [marqueeWrapperRef, childrenRef]);

  return (
    <>
      <div className="marquee-wrapper" ref={marqueeWrapperRef}>
        {enableMarquee ? (
          <ReactMarquee delay={delay}>{children}</ReactMarquee>
        ) : (
          <div
            ref={childrenRef}
            className={
              enableMarquee === null
                ? 'position-absolute truncate'
                : 'd-block truncate'
            }
          >
            {children}
          </div>
        )}
      </div>
    </>
  );
};

export default Marquee;
